// extracted by mini-css-extract-plugin
export default {"container":"KeyDescription_container__b7zK7"};